class InvalidPayload extends Error {
    constructor(...args) {
        super(...args);
        Error.captureStackTrace(this, InvalidPayload);
    }
}

export default InvalidPayload;
